import { Component, OnInit } from '@angular/core';
import { StaffImportViewService } from 'app/modules/staff-count/services/staff-import-view.service';
import { StaffImportService } from 'app/modules/staff-count/services/staff-import.service';
import { AttributeImportViewService } from '../services/attribute-import-view.service';
import { AttributeImportService } from '../services/attribute-import.service';

@Component({
    selector: 'app-attribute-excel-panel',
    templateUrl: './attribute-excel-panel.component.html',
    styleUrls: ['./attribute-excel-panel.component.scss'],
    standalone: false
})
export class AttributeExcelPanelComponent implements OnInit {

  displayedColumns: string[] = ['name', 'columnName'];    // Name is alphabetic letter, and columnName is name in table camposImportacion
  dataSource: { position: number, name: string, columnName: string}[] = [];
  camposImportacionList: any[]= [];
  selectedCamposImportacionList: any[]= [];

  constructor(
    public attributeImportService: AttributeImportService,
    public attributeImportViewService: AttributeImportViewService
  ) { }

  ngOnInit() {
    this.populateExcelColumnList('A1:IV256');
    this.populateDropdown();
  }

  populateDropdown(){
    this.camposImportacionList = ['Atributo 1', 'Atributo 2', 'Atributo 3', 'Atributo 4',
    'Atributo 5', 'Atributo 6','Atributo 7', 'Atributo 8', 'Atributo 9', 'Atributo 10', 'Atributo 11', 'Atributo 12']
  }

  populateExcelColumnList(range: string){    
    this.dataSource = [];
    var i,
    rangeNum = range.split(':').map(function(val) {
      if(val){
        var temp =  val.replace(/[0-9]/g, '');
        var num = 0; 
        for (var t = 0; t < temp.length; t++) {
          num = num * 26 + temp.charCodeAt(t) - 0x40;
        }  
         return num - 1;
      }
    }), start = rangeNum[0], end = rangeNum[1] + 1;
    for (i = start; i < end ; i++) {
      var columnNo = 1 + i;
      var columnName = null;
      if(this.selectedCamposImportacionList.length !=0){
        var obj = this.selectedCamposImportacionList.find(x=>x.columna == columnNo);
        if(obj)
          columnName = obj.campo;
      }
      this.dataSource.push({ position: columnNo , name: this.numToAlpha(i), columnName: columnName});      
    }    
  }

  numToAlpha(num: number) {
    var alpha = '';  
    for (;num >= 0; num = parseInt((num / 26).toString(), 10) - 1) {
      alpha = String.fromCharCode(num % 26 + 0x41) + alpha;
    }  
    return alpha;
  }

  getselectedColumnsData(){
    return this.dataSource.filter(x=>x.columnName != null);
  }

  clearExcelColumnList(){
    this.selectedCamposImportacionList = [];
    this.populateExcelColumnList('A1:IV256');
  }
  
  clearColumn(data:any){
    data.columnName = null;
  }

}
